// extracted by mini-css-extract-plugin
export default {"box__style":"IconWithText_box__style__vOhED"};